import styled from "styled-components";

type ContainerType = {
    border: string;
}

export const Container = styled.div<ContainerType>`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: .5px solid ${props => props.border};
  border-radius: 4px;
`;
